import { z } from 'zod';

import { isYoutubeLinkValid } from '@/shared/lib/validators';

export const LANDING_FLOW_STORAGE_KEY = 'landing_flow';

export const LandingFlowKind = {
  videoTranscript: 'video_transcript',
} as const;

const LANDING_MEDIA_ID_PATTERN = /^[\w-]+$/;

export type LandingFlowKindType = (typeof LandingFlowKind)[keyof typeof LandingFlowKind];

const DubLandingFlowBaseSchema = z.object({
  kind: z.literal(LandingFlowKind.videoTranscript),
  target_lang: z.string().min(1),
});

const DubLandingFlowByMediaLinkDataSchema = DubLandingFlowBaseSchema.extend({
  media_link: z
    .string()
    .url()
    .refine((value) => isYoutubeLinkValid(value), { message: 'Only YouTube links are allowed' }),
}).strict();

const DubLandingFlowByMediaIdDataSchema = DubLandingFlowBaseSchema.extend({
  media_id: z.string().regex(LANDING_MEDIA_ID_PATTERN),
}).strict();

export const DubLandingFlowDataSchema = z.union([DubLandingFlowByMediaLinkDataSchema, DubLandingFlowByMediaIdDataSchema]);

export const LandingFlowDataSchema = DubLandingFlowDataSchema;

export type DubLandingFlowData = z.infer<typeof DubLandingFlowDataSchema>;
export type LandingFlowData = z.infer<typeof LandingFlowDataSchema>;
